import { render } from "./AnnMaintain.vue?vue&type=template&id=236b3954&scoped=true&ts=true"
import script from "./AnnMaintain.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnMaintain.vue?vue&type=script&setup=true&lang=ts"

import "./AnnMaintain.vue?vue&type=style&index=0&id=236b3954&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236b3954"],['__file',"src/views/home/AnnMaintain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "236b3954"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('236b3954', __exports__)) {
    console.log('reload')
    api.reload('236b3954', __exports__)
  }
  
  module.hot.accept("./AnnMaintain.vue?vue&type=template&id=236b3954&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('236b3954', render)
  })

}


export default __exports__